import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext.jsx';
import { firebaseApp } from '../firebase.js';
import { getFirestore, doc, onSnapshot } from 'firebase/firestore';

export const useVerificationStatus = () => {
  const { user } = useAuth();
  const [verificationStatus, setVerificationStatus] = useState({
    isVerified: false,
    loading: true
  });

  useEffect(() => {
    if (!user) {
      setVerificationStatus({ isVerified: false, loading: false });
      return;
    }

    const db = getFirestore(firebaseApp);
    const profileRef = doc(db, 'userProfiles', user.id);

    const unsubscribe = onSnapshot(profileRef, (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        setVerificationStatus({
          isVerified: data.skillsVerified || false,
          verificationScore: data.verificationScore,
          verificationDate: data.verificationDate?.toDate ? data.verificationDate.toDate() : data.verificationDate,
          personaVerified: data.personaVerified || false,
          personaStatus: data.personaStatus,
          personaVerifiedAt: data.personaVerifiedAt?.toDate ? data.personaVerifiedAt.toDate() : data.personaVerifiedAt,
          // Combined verification: both skills and persona verified
          fullyVerified: (data.skillsVerified || false) && (data.personaVerified || false),
          loading: false
        });
      } else {
        setVerificationStatus({ 
          isVerified: false, 
          personaVerified: false,
          fullyVerified: false,
          loading: false 
        });
      }
    }, (error) => {
      console.error('Error listening to verification status:', error);
      setVerificationStatus({ 
        isVerified: false, 
        personaVerified: false,
        fullyVerified: false,
        loading: false 
      });
    });

    return () => unsubscribe();
  }, [user]);

  return verificationStatus;
};

